module.exports = __webpack_public_path__ + "static/media/Carosel P 1.36416250.svg";